var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('MovieModal',{model:{value:(_vm.videoModalOpen),callback:function ($$v) {_vm.videoModalOpen=$$v},expression:"videoModalOpen"}}),_c('SnackBar'),_c('GoToTopBtn'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }